'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hour;


// WEBPACK FOOTER //
// ./~/sugar-date/number/hour.js